interface Props {
  val: string;
  onChange: (val: string) => void;
  allowBlank?: boolean;
}

/**
 * 文字列入力フィールド
 * @param props
 * @returns
 */
const InputEmailText = ({ val, onChange, allowBlank }: Props) => {
  return (
    <input
      type="email"
      value={val}
      onChange={e => onChange(e.target.value)}
      required={!allowBlank}
    />
  );
};
export default InputEmailText;
